/**
 * LogTabNavigation Component
 * Tab navigation for the System Logs page
 */

import { MessageSquare, ThumbsUp, AlertTriangle, Activity } from 'react-feather';
import { LogTab } from '../../types/logs';

interface LogTabNavigationProps {
  activeTab: LogTab;
  onTabChange: (tab: LogTab) => void;
}

const tabs: { id: LogTab; label: string; icon: React.ElementType }[] = [
  { id: 'conversations', label: 'Conversations', icon: MessageSquare },
  { id: 'feedback', label: 'Feedback', icon: ThumbsUp },
  { id: 'errors', label: 'Errors', icon: AlertTriangle },
  { id: 'activity', label: 'Activity', icon: Activity }
];

export default function LogTabNavigation({ activeTab, onTabChange }: LogTabNavigationProps) {
  return (
    <div className="border-b border-gray-200">
      <nav className="flex -mb-px">
        {tabs.map(({ id, label, icon: Icon }) => {
          const isActive = activeTab === id;
          return (
            <button
              key={id}
              onClick={() => onTabChange(id)}
              className={`
                flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors
                ${isActive
                  ? 'border-blue-600 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
            >
              <Icon size={16} />
              {label}
            </button>
          );
        })}
      </nav>
    </div>
  );
}
